import { Moment } from 'moment-timezone';

export const TimeZoneProvider = {
  provide: 'timeZone',
  deps: ['moment'],
  // @ts-ignore
  useFactory: (moment: Moment) => moment.tz.guess(),
};
